/**
 * Skeleton loader para mostrar mientras el grid de apartamentos carga.
 * Estructura idéntica a ApartmentCard para evitar layout shift.
 *
 * Decisión Gemini v6 (P1): mejor que un spinner — el usuario ve "estoy
 * cargando 6 apartamentos" en lugar de "el sitio está roto".
 */
export default function ApartmentCardSkeleton() {
  return (
    <div className="relative w-full animate-pulse overflow-hidden rounded-2xl border border-[#E8E1D4] bg-[#FDFBF7] shadow-[0_2px_16px_-4px_rgba(0,0,0,0.06)]">
      {/* Imagen placeholder */}
      <div className="relative aspect-[3/2] w-full overflow-hidden bg-stone-200 sm:aspect-[4/3]">
        <div className="absolute inset-x-0 top-0 bg-gradient-to-b from-black/20 via-black/5 to-transparent p-3 sm:p-4">
          <div className="h-3.5 w-3/4 rounded bg-white/55" />
          <div className="mt-1.5 h-3 w-1/2 rounded bg-white/45" />
        </div>
        <div className="absolute inset-x-0 bottom-0 flex items-center justify-between bg-gradient-to-t from-black/20 via-black/5 to-transparent p-3 sm:p-4">
          <div className="h-3 w-16 rounded bg-white/55" />
          <div className="h-5 w-16 rounded-full bg-white/80" />
        </div>
      </div>

      {/* Sección info */}
      <div className="p-4">
        {/* Precio */}
        <div className="mb-2">
          <div className="flex items-baseline justify-between gap-2">
            <div className="h-3 w-12 rounded bg-gray-200" />
            <div className="h-5 w-24 rounded bg-gray-300" />
          </div>
          <div className="mt-1 h-2.5 w-32 rounded bg-gray-200" />
        </div>

        {/* Metadata centrada */}
        <div className="mt-2 border-t border-[#E8E1D4] pt-2">
          <div className="mx-auto h-3 w-44 max-w-[80%] rounded bg-gray-200" />
        </div>
      </div>
    </div>
  );
}

/**
 * Grid de skeletons (default 6 = una pantalla).
 */
export function ApartmentGridSkeleton({ count = 6 }: { count?: number }) {
  return (
    <div
      role="status"
      aria-live="polite"
      aria-label="Cargando apartamentos disponibles"
      className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-[repeat(3,minmax(0,1fr))] xl:grid-cols-4"
    >
      {Array.from({ length: count }).map((_, i) => (
        <ApartmentCardSkeleton key={i} />
      ))}
    </div>
  );
}
